// extracted by mini-css-extract-plugin
module.exports = {"blink":"style_blink__aj0JC","fadeinout":"style_fadeinout__1rRRF","blinkdropshadow":"style_blinkdropshadow__E8f8r","fadeinoutdropshadow":"style_fadeinoutdropshadow__2ZWWk"};